import { InstitutionType } from '../entities/Institution';

interface GetInstitutionTypeProps {
  value: InstitutionType;
  label: InstitutionType;
}

/**
 * ⚠️ `Plataforma CINCO` não está na lista de propósito: é a marca do tenant
 * sintético, criada por migration com id fixo, e o back recusa atribuí-la a outra
 * instituição (0.13).
 */
const getInstitutionType: GetInstitutionTypeProps[] = [
  {
    value: 'Clínica',
    label: 'Clínica',
  },
  {
    value: 'Consultório',
    label: 'Consultório',
  },
  {
    value: 'Homecare',
    label: 'Homecare',
  },
  {
    value: 'Hospital',
    label: 'Hospital',
  },
  {
    value: 'Laboratório',
    label: 'Laboratório',
  },
  {
    value: 'Município',
    label: 'Município',
  },
  {
    value: 'Secretaria de Saúde',
    label: 'Secretaria de Saúde',
  },
  {
    value: 'Outros',
    label: 'Outros',
  },
];

export default getInstitutionType;
